import { Authenticated } from "../../authenticated";
import { Dashboard } from "../../dashboard";
import { LastAction } from "../last-action";
import { Loader } from "../loader";
//Register all reducers here (StoreConfig typed objects)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const storeConfigs = [
    Authenticated.Store,
    Loader.Store,
    LastAction.Store,
    Dashboard.Store,
];
